import { render, staticRenderFns } from "./PlanejamentoAcaoVerbaVariavelFormCampos.vue?vue&type=template&id=80d79738"
import script from "./PlanejamentoAcaoVerbaVariavelFormCampos.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoVerbaVariavelFormCampos.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoVerbaVariavelFormCampos.vue?vue&type=style&index=0&id=80d79738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports